import { Injectable, ViewContainerRef } from '@angular/core';

import { SettingsEntry } from './settings-entry';

@Injectable()
export class SupportEntry implements SettingsEntry {
    label: string;

    constructor() {
        this.label = 'Contact Ixia Support';
    }

    activate(viewContainerRef: ViewContainerRef) {
        let url = 'https://support.ixiacom.com/contact/support';

        window.open(url, '_blank');
    }

    clean() { }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/setting-entries/support-entry.ts